export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Business contacts
export const WHATSAPP_NUMBER = "917827437909"; // E.164 without '+'
export const WHATSAPP_DISPLAY = "+91 78274 37909";
export const SUPPORT_EMAIL = "support@herbalmax.in";

export const PRICE_INR = 1999;
export const PRODUCT_NAME = "VARDHAN";
export const PRODUCT_TAGLINE = "Detox & Recovery Support";

export const PRODUCT_HERO_IMAGE =
    "https://customer-assets-v7afamib.emergentagent.net/job_2237a328-d9d8-4454-b9eb-b72e43ee1dd1/artifacts/o7mnp1l1_ChatGPT%20Image%20Jul%2021%2C%202026%2C%2011_31_38%20AM.png";

export const INGREDIENT_IMAGES = {
    ashwagandha: "https://images.unsplash.com/photo-1748249603957-6fd18c59dc0b",
    brahmi: "https://images.unsplash.com/photo-1750437527283-2958f14e15ce",
    sage: "https://images.pexels.com/photos/17506694/pexels-photo-17506694.jpeg",
};

export const DISCLAIMER =
    "VARDHAN is an Ayurvedic proprietary formulation intended to support overall wellness. It is not intended to diagnose, treat, cure or prevent any disease. Individual results may vary.";
